import React from 'react'

export default class PostList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  static getDerivedStateFromProps(nextProps, prevState) {

    return null
  }
  componentDidMount() {
    this.setup(this.props)
  }
  setup() {
    const dataPath = `../data/`
    const indexesPath = `${dataPath}/indexes`
    const fileName = `_.json`
    const filePath = `${indexesPath}/${fileName}`
    fetch(filePath).then(response=>{
      if(response.ok) {
        return response.json()
      }
      throw new Error('Network response was not ok.');
    }).then(data=>{
      const aggregates = data
      if (Array.isArray(aggregates)&&aggregates.length>0) {
        this.setState({aggregates:aggregates},()=>{
          this.fetchPosts(indexesPath,aggregates)
        })
      } else {
        this.setState({msg:'No list!'})
      }
    }).catch(e=>{
      this.setState({msg:'Something is not right'+e.message})
    })
  }
  fetchPosts(indexesPath,aggregates) {
    const name = 'q_latest-posts'
    const aggregate = aggregates.find(e=>e.name===name)
    if (typeof(aggregate)==='object'&&aggregate!==null) {
      const count = aggregate.count
      //const size = aggregate.size
      //const pageCount = aggregate.pageCount
      let index = 0
      if (count>0) {
        const fileName = `${name}_${index}.json`
        const filePath = `${indexesPath}/${fileName}`
        fetch(filePath).then(response=>{
          if(response.ok) {
            return response.json()
          }
          throw new Error('Network response was not ok.');
        }).then(data=>{
          const posts = data
          if (Array.isArray(posts)&&posts.length>0) {
            this.setState({posts:(this.state.posts||[]).concat(posts)})
          }
        }).catch(e=>{
          this.setState({msg:'Something is not right'+e.message})
        })
      }
    }
  }
  render() {
    return (
      <div>
        <h1>Post List</h1>
        <div>
          {
            (this.state.posts||[]).map((post,index)=>(
              <div key={index}>
                <h1>{post.title}</h1>
                <p>{post.lead}</p>
                <p>{post.body}</p>
              </div>
            ))
          }
        </div>
        <div>
          <pre><code>
            {JSON.stringify(this.state.posts,null,2)}
          </code></pre>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PostList.js